import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import CustomerForm from '@/modules/customer/components/CustomerForm.vue';
import { Customer, useCustomer } from '@/modules/customer/Customer';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const customer = ref<Customer | null>(null);

const load = async () => {
	try {
		const response = await useCustomer().get(route.params.id as string);
		if (response) {
			customer.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'customer.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	customer.value = u;
	Flash.success($gettext('Kunden har sparats.'));
};

const cancel = () => {
	router.push({ name: 'customer.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomerForm, {
    "page-title": _unref($gettext)('Redigera kund'),
    customer: customer.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": false
  }, null, 8, ["page-title", "customer"]))
}
}

})